import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import GridTable from "../../components/GridTable";
import useAuth from "../../hooks/useAuth";
import { getEmpAssignedAppraisal } from "../../api/appraisalApi";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { Button as MButton } from "@mui/material";
import {
  getStatusNameByValue,
  ROLE_NAMES,
  ROLES,
  STATUS,
} from "../../uitls/Utils";
import Loader from "../../components/Loader";
import { clearAppraisalCache } from "./appraisalSlice";
const EmpAssignedAppraisal = () => {
  const { auth } = useAuth();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { empAssignedAppraisalList, loading } = useSelector(
    (state) => state.appraisalState
  );

  const navigate = useNavigate();
  const userId = auth?.user?.id;

  const currentPageStatus = searchParams.get("status");
  
  // Check if we're on the self-appraisal page
  const isSelfAppraisalPage = location.pathname === "/mgr/self-appraisal";

  // Check if user is a child manager (has managerId)
  const isChildManager = auth?.user?.managerId && 
                         auth.user.managerId !== "" && 
                         auth.user.managerId !== "N/A";

  // Memoize filteredData to prevent unnecessary updates, sorted by createdDate descending
  // Note: Backend handles filtering for child managers when selfOnly=true, so no client-side filtering needed
  const filteredData = useMemo(() => {
    if (!Array.isArray(empAssignedAppraisalList)) return [];
    
    // Sort by createdDate descending (newest first)
    return [...empAssignedAppraisalList].sort((a, b) => {
      const dateA = new Date(a.createdDate || 0);
      const dateB = new Date(b.createdDate || 0);
      return dateB - dateA; // Descending order (newest first)
    });
  }, [empAssignedAppraisalList]);

  useEffect(() => {
    const status = currentPageStatus;
    // For child managers on self-appraisal page, pass selfOnly=true to get their own appraisals
    const selfOnly = auth?.roleId === ROLES.mgr && isChildManager && isSelfAppraisalPage;
    dispatch(getEmpAssignedAppraisal({ userId, status, selfOnly }));
  }, [dispatch, userId, currentPageStatus, auth?.roleId, isChildManager, isSelfAppraisalPage]);

  const startSbumittion = useCallback((row, actionType) => {
    // dispatch(updateSelectedAppraisal(null))

    dispatch(clearAppraisalCache());

    setTimeout(() => {
    if (auth?.roleId === ROLES.mgr) {
      navigate("/mgr/create-appraisal?id=" + row.id + "&action=" + actionType+ "&prevPage=" + location.pathname );
    } else {
      navigate("/emp/create-appraisal?id=" + row.id + "&action=" + actionType+"&prevPage=" +location.pathname );
    }
    }, 600);
  }, [auth?.roleId, dispatch, navigate]);

  const showViewButton = (status,row) => {
    const {
      NOT_STARTED,
      UNDER_REVIEW,
      APPROVED,
      CHANGE_REQUEST,
      NEED_DISCUSSION,
      FINAL_REVIEWED,
      IN_PROGRESS,
    } = STATUS;
    
    // Check if user is a child manager (has managerId)
    const isChildManager = auth?.user?.managerId && 
                           auth.user.managerId !== "" && 
                           auth.user.managerId !== "N/A";
   

                           //user
                           if(row.assignedUser?.id==auth?.user?.id){
                             if(![NOT_STARTED].includes(status)) return true
                           }
                           //manager
                           else if( row.assignedUser?.id!=auth?.user?.id && auth.roleId === ROLE_NAMES.Manager){
                            if([UNDER_REVIEW,CHANGE_REQUEST,APPROVED,NEED_DISCUSSION,FINAL_REVIEWED].includes(status)) return true
                           }
                           //admin
                           else{
   if([APPROVED,FINAL_REVIEWED].includes(status)) return true
                         
                           }

    // if (auth.roleId === ROLE_NAMES.User) {
    //   return ![NOT_STARTED].includes(status);
    // } else if (auth.roleId === ROLE_NAMES.Manager) {
    //   // For child managers viewing their own appraisals, show view button for all statuses except NOT_STARTED
    //   // if (isChildManager) {
    //   //   return ![NOT_STARTED].includes(status);
    //   // }
    //   // For main managers reviewing employee appraisals
    //   return [
    //     UNDER_REVIEW,
    //     CHANGE_REQUEST,
    //     NEED_DISCUSSION,
    //     FINAL_REVIEWED,
    //     APPROVED,
    //     IN_PROGRESS,
    //   ].includes(status);
    // }
  };

  const showSubmitButton = (status,row) => {

    const {
      NOT_STARTED,
      UNDER_REVIEW,
      APPROVED,
      CHANGE_REQUEST,
      NEED_DISCUSSION,
      FINAL_REVIEWED,
      IN_PROGRESS,
      COMPLETED
    } = STATUS;

    //user
                           if(row.assignedUser?.id==auth?.user?.id){
                             if([NOT_STARTED].includes(status)) return true
                           }
                           //manager
                           else if( row.assignedUser?.id!=auth?.user?.id && auth.roleId === ROLE_NAMES.Manager){
                            if([COMPLETED].includes(status)) return true
                           }
                           //admin
                           else{
   if([APPROVED].includes(status)) return true
                         
                           }
    // const { NOT_STARTED, COMPLETED, IN_PROGRESS } = STATUS;
    
    // // Check if user is a child manager (has managerId)
    // const isChildManager = auth?.user?.managerId && 
    //                        auth.user.managerId !== "" && 
    //                        auth.user.managerId !== "N/A";

    // return (
    //   (auth.roleId === ROLE_NAMES.User && [NOT_STARTED].includes(status)) ||
    //   (auth.roleId === ROLE_NAMES.Manager && [COMPLETED].includes(status)) ||
    //   // Child managers can submit their own appraisals when NOT_STARTED or IN_PROGRESS
    //   (auth.roleId === ROLE_NAMES.Manager && isChildManager && [NOT_STARTED, IN_PROGRESS].includes(status))
    // );
  };

  const columns = useMemo(() => [
    {
      field: "templateTitle",
      headerName: "Appraisal Name",
      width: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <span>{params.row.appraisalTemplate.templateTitle}</span>
      ),
    },

    {
      field: "employeeName",
      headerName: "Employee Name",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <span>
          {params.row.assignedUser?.firstName || "-"}{" "}
          {params.row.assignedUser?.lastName || "-"}
        </span>
      ),
    },
    {
      field: "manager",
      headerName: "Manager Name",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <span>{params.row.assignedUser.manager?.name}</span>
      ),
    },

    {
      field: "currentAppraisalStatus",
      headerName: "Status",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => <span>{getStatusNameByValue(params.value)}</span>,
    },
    {
      field: "userSubmissionEndDate",
      headerName: "Last Submission Date",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "quickAction",
      headerName: "Quick Action",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const isNotStarted = params.row.currentAppraisalStatus === STATUS.NOT_STARTED;
        const buttonText = isNotStarted ? "Start" : "Submit";
        
        return (
          <div className="flex  justify-between">
            {showSubmitButton(params.row.currentAppraisalStatus,params.row,auth) && (
              <MButton
                variant="outlined"
                onClick={() => startSbumittion(params.row, "Submit")}
                className="mr-3"
              >
                {buttonText}
              </MButton>
            )}
            {showViewButton(params.row.currentAppraisalStatus,params.row,auth) && (
              <MButton
                variant="outlined"
                onClick={() => startSbumittion(params.row, "View")}
                className="mr-3"
              >
                View
              </MButton>
            )}
          </div>
        );
      },
    },
  ], [startSbumittion]);
  return (
    <div className="pt-4 md:pt-6 2xl:pt-10 w-full px-4 md:px-6 lg:px-8">
      {loading && <Loader />}
      <GridTable
        rowData={filteredData}
        columnData={columns}
        toolTipName={"Create Self Appraisal"}
        isFilterAdded={false}
        hideSearchBar={false}
      />
    </div>
  );
};

export default EmpAssignedAppraisal;
